import { Routes } from '@angular/router';
import { XplorePageComponent } from './views/pages/xplore-page/xplore-page.component';
import { SearchPageComponent } from './views/pages/search-page/search-page.component';
import { XploreItemInfoPageComponent } from './views/pages/xplore-item-info-page/xplore-item-info-page.component';
import { LoginPageComponent } from './views/pages/login-page/login-page.component';
import { SignupPageComponent } from './views/pages/signup-page/signup-page.component';
import { XploreItemPreviewComponent } from './views/debug/xplore-item-preview/xplore-item-preview.component';
import { AuthGuard } from './services/guard/auth.guard';
import { FavoritesPageComponent } from './views/pages/favorites-page/favorites-page.component';
import { LogoutPageComponent } from './views/pages/logout-page/logout-page.component';
import { LoadUserComponent } from './views/pages/load-user/load-user.component';
import { HomeComponent } from './views/pages/home/home.component';
import { ForgotPasswordPageComponent } from './views/pages/forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './views/pages/reset-password-page/reset-password-page.component';
import { NotFoundPageComponent } from './views/pages/not-found-page/not-found-page.component';
import { UgcCreatePageComponent } from './views/pages/ugc-create-page/ugc-create-page.component';
import { UgcProgramPageComponent } from './views/pages/ugc-program-page/ugc-program-page.component';

export const APP_ROUTES: Routes = [
  { path: 'explore/info/:id', component: XploreItemInfoPageComponent },
  { path: 'explore/:id', component: XplorePageComponent },
  { path: 'explore/:id/:metaName', component: XplorePageComponent },
  { path: 'explore', component: XplorePageComponent },
  { path: 'search', component: SearchPageComponent },
  { path: 'login', component: LoginPageComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordPageComponent },
  { path: 'reset-password', component: ResetPasswordPageComponent },
  { path: '404', component: NotFoundPageComponent },
  { path: 'load-user', component: LoadUserComponent },
  { path: 'logout', component: LogoutPageComponent },
  { path: 'signup', component: SignupPageComponent },
  { path: 'favorites', component: FavoritesPageComponent, canActivate: [AuthGuard] },
  { path: 'ugc/program', component: UgcProgramPageComponent, canActivate: [AuthGuard] },
  { path: 'ugc/new', component: UgcCreatePageComponent, canActivate: [AuthGuard] },
  { path: '', component: HomeComponent },
  { path: 'debug/preview', component: XploreItemPreviewComponent },
  {
    path: 'map',
    loadChildren: () => import('./views/pages/map/map.routes').then((m) => m.MAP_ROUTES)
  },
  {
    path: 'map/:id',
    loadChildren: () => import('./views/pages/map/map.routes').then((m) => m.MAP_ROUTES)
  },
  {
    path: 'immersive/:xploreId',
    loadChildren: () => import('./views/pages/immersive/immersive.routes').then((m) => m.IMMERSIVE_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./views/pages/profile/profile.routes').then((m) => m.PROFILE_ROUTES)
  },
  { path: '**', redirectTo: '404' }
];
